<template>
    <div class="navbar navbar-expand-md navbar-light fixed-bottom" >
        <div class="text-center d-md-none w-100">
            <button type="button" class="navbar-toggler dropdown-toggle collapsed" data-toggle="collapse" data-target="#navbar-second" aria-expanded="false">
                <i class="icon-menu mr-2"></i>
                {{ translate('buttons.control_panel') }}
            </button>
        </div>

        <div class="navbar-collapse collapse" id="navbar-second">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "FixedBottomNavbar",
    mounted() {
        document.body.classList.add('navbar-bottom');
    },
    beforeUnmount() {
        document.body.classList.remove('navbar-bottom');
    }
}
</script>
<style scoped>
.navbar {
    z-index: 1000
}
</style>